
import { Sheet, SheetContent } from '@/components/ui/sheet';
import Sidebar from '../Sidebar';

interface MobileSidebarProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const MobileSidebar = ({ open, onOpenChange }: MobileSidebarProps) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="p-0 w-full max-w-[280px] sm:max-w-[320px] border-r shadow-lg">
        <Sidebar isMobile={true} onNavigation={() => onOpenChange(false)} />
      </SheetContent>
    </Sheet>
  );
};
